const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;

const pluralised = (count: number, unit: string): string => `${count} ${unit}${count === 1 ? '' : 's'} ago`;

export function relativeTimeSince(detectedAt: Date, now: Date): string {
  const elapsedSeconds = Math.floor((now.getTime() - detectedAt.getTime()) / 1000);

  if (elapsedSeconds < SECONDS_PER_MINUTE) {
    return 'just now';
  }

  if (elapsedSeconds < SECONDS_PER_HOUR) {
    return pluralised(Math.floor(elapsedSeconds / SECONDS_PER_MINUTE), 'minute');
  }

  if (elapsedSeconds < SECONDS_PER_DAY) {
    return pluralised(Math.floor(elapsedSeconds / SECONDS_PER_HOUR), 'hour');
  }

  return pluralised(Math.floor(elapsedSeconds / SECONDS_PER_DAY), 'day');
}
